import {
  useWSModal,
  WSActions,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

const ModalBalanceInfo: React.FC<{ onClose(): void }> = ({ onClose }) => {
  return (
    <WSList gap="XL">
      <WSList gap="L">
        <WSText.ParagraphSm color="gray500">
          Here's what each balance means:
        </WSText.ParagraphSm>
        <WSList gap="XS">
          <WSText.ParagraphSm weight="medium" color="gray600">
            Available balance
          </WSText.ParagraphSm>
          <WSText.ParagraphSm color="gray500">
            The amount of money you can use right now. This amount may change as
            new transactions post.
          </WSText.ParagraphSm>
        </WSList>

        <WSList gap="XS">
          <WSText.ParagraphSm weight="medium" color="gray600">
            Total balance
          </WSText.ParagraphSm>
          <WSText.ParagraphSm color="gray500">
            The total amount of money recorded in your account including money
            that isn't ready to use yet (such as pending transactions,
            authorization holds or deposits that are not yet available.)
          </WSText.ParagraphSm>
        </WSList>

        <WSList gap="XS">
          <WSText.ParagraphSm weight="medium" color="gray600">
            Pending amounts
          </WSText.ParagraphSm>
          <WSText.ParagraphSm color="gray500">
            The amount of money that is still processing (such as pending
            transactions, authorization holds or deposits that are not yet
            available.)
          </WSText.ParagraphSm>
        </WSList>
      </WSList>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </WSList>
  );
};

export function useModalBalanceInfo() {
  return useWSModal(ModalBalanceInfo, {
    title: "Learn more",
    size: "S"
  });
}
